module.exports = __webpack_public_path__ + "static/media/Icon.ccbef190.svg";